import { render, staticRenderFns } from "./leagueWinloseDetail.vue?vue&type=template&id=08f455f4&lang=pug&"
import script from "./leagueWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./leagueWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports